<ng-container [formGroup]="form">
    <ng-select id="{{id}}"
        labelForId="{{id}}"
        placeholder="{{placeholder}}"
        formControlName="selectCtrl"
        [searchable]="true"
        [items]="items"
        [virtualScroll]="true"
        [multiple]="multiple"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue">
    </ng-select>
</ng-container>
